// extracted by mini-css-extract-plugin
module.exports = {"container":"TechStack_container__2cpXh","tags":"TechStack_tags__12hlp","tag":"TechStack_tag__2kcH-"};